/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type system_status_SystemStatusEventsArgs = {
    event_type?: system_status_SystemStatusEventsArgs.event_type;
    status?: system_status_SystemStatusEventsArgs.status;
};

export namespace system_status_SystemStatusEventsArgs {

    export enum event_type {
        INCIDENT = 'incident',
        PLANNED_MAINTENANCE = 'planned_maintenance',
    }

    export enum status {
        SCHEDULED = 'scheduled',
        ONGOING = 'ongoing',
        COMPLETED = 'completed',
    }


}

